import React from 'react';
import './slider.css'

function LogoSlider() {
  return (
    <>
    <section className='Discount background NewArrivals logoslider_container'>
    </section>
  </>
  )
}

export default LogoSlider